export const COMBO_FILTER_URL_ROUTE = '(?<tagCode>[a-z_0-9-]+)-tag-(?<tagId>[0-9]+)';
export const ROUTER_QUERY_TAG_OR_COLLECTION_KEY = 'slug';
